<template>
  <icon type="ios-headset" size="24" color="#7F92A9" />
</template>

<script>
  export default {};
</script>

<style scoped></style>
